
import {
  REQUEST_SOURCES,
  REQUEST_SOURCES_ERROR,
  RECEIVE_SOURCES,
  CREATED_SOURCE_SETTING
} from 'actions'

const initialState = {}

const initialWorkspaceState = {
  isRequesting: false,
  didRequestFail: false,
  hasRequested: false,
  data: {}
}

const initialSourceState = {
  isRequesting: false,
  didRequestFail: false,
  didInvalidate: false,
  data: {}
}

export default function (state = initialState, { type, payload = {} }) {
  // payload can be any type, includ null (https://github.com/acdlite/flux-standard-action#payload)
  // here, if payload === null, this reducer throws
  if (payload === null) return state

  switch (type) {
    case REQUEST_SOURCES:
      return workspaceReducer(payload.workspaceSlug, state, {
        isRequesting: true,
        didRequestFail: false
      })
    case REQUEST_SOURCES_ERROR:
      return workspaceReducer(payload.workspaceSlug, state, {
        isRequesting: false,
        didRequestFail: true
      })
    case RECEIVE_SOURCES:
      return workspaceReducer(payload.workspaceSlug, state, {
        isRequesting: false,
        didRequestFail: false,
        hasRequested: true,
        data: toIDMap(payload.response)
      })
    case CREATED_SOURCE_SETTING:
      return workspaceReducer(payload.workspaceSlug, state, {
        data: {
          ...(state[payload.workspaceSlug] || {}).data,
          ...toIDMap([payload.response])
        }
      })
    default:
      return state
  }
}

function workspaceReducer (workspaceSlug, previous, next) {
  return {
    ...previous,
    [workspaceSlug]: {
      ...initialWorkspaceState,
      ...previous[workspaceSlug],
      ...next
    }
  }
}

/**
 * Map `array` by each item's id.
 */

function toIDMap (arr) {
  const map = {}
  for (let i = 0; i < arr.length; i++) {
    map[arr[i].id] = {
      ...initialSourceState,
      data: arr[i]
    }
  }
  return map
}



// WEBPACK FOOTER //
// ./reducers/sources.js